import React from "react";

import { Box, Container, Grid, Link, Typography } from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDiscord, faTwitch } from "@fortawesome/free-brands-svg-icons";
import {
  BCPFacebook,
  BCPInstagram,
  BCPThreads,
  BCPTwitterX,
  BCPYoutube
} from "../../components/icons/bcp/BCPIcons";
import { getEnvironmentVariable } from "../../global/environmentVariables";
const getSocials = () => {
  let socials = {};
  if (
    getEnvironmentVariable("SOCIALS") !== undefined &&
    getEnvironmentVariable("SOCIALS") !== "NOT SET"
  ) {
    try {
      socials = JSON.parse(getEnvironmentVariable("SOCIALS"));
    } catch (err) {}
  }
  return socials;
};

export default function FindUs() {
  return (
    <Box sx={{ width: "100%" }}>
      <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
        <Grid
          container
          sx={{
            gap: 2,
            p: 2
          }}
        >
          <Grid item xs={12}>
            <Typography variant="h3" gutterBottom>
              Find Us
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Grid
              container
              spacing={3}
              justifyContent="center"
              sx={{
                fontSize: "30px"
              }}
            >
              {getSocials().facebook && (
                <Grid item xs={12}>
                  <Link
                    color="inherit"
                    underline="none"
                    href={getSocials().facebook}
                    target="_Blank"
                  >
                    <BCPFacebook
                      sx={{ fontSize: "inherit", width: "inherit" }}
                    />
                    <span
                      style={{
                        marginLeft: "8px"
                      }}
                    >
                      {getSocials().facebook.replace(
                        "https://www.facebook.com",
                        ""
                      )}
                    </span>
                  </Link>
                </Grid>
              )}
              {getSocials().twitter && (
                <Grid item xs={12}>
                  <Link
                    color="inherit"
                    underline="none"
                    href={getSocials().twitter}
                    target="_Blank"
                  >
                    <BCPTwitterX
                      sx={{ fontSize: "inherit", width: "inherit" }}
                    />
                    <span
                      style={{
                        marginLeft: "8px"
                      }}
                    >
                      {getSocials().twitter.replace("https://twitter.com", "")}
                    </span>
                  </Link>
                </Grid>
              )}
              {getSocials().instagram && (
                <Grid item xs={12}>
                  <Link
                    color="inherit"
                    underline="none"
                    href={getSocials().instagram}
                    target="_Blank"
                  >
                    <BCPInstagram
                      sx={{ fontSize: "inherit", width: "inherit" }}
                    />
                    <span
                      style={{
                        marginLeft: "8px"
                      }}
                    >
                      {getSocials().instagram.replace(
                        "https://www.instagram.com",
                        ""
                      )}
                    </span>
                  </Link>
                </Grid>
              )}
              {getSocials().discord && (
                <Grid item xs={12}>
                  <Link
                    color="inherit"
                    underline="none"
                    href={getSocials().discord}
                    target="_Blank"
                  >
                    <FontAwesomeIcon icon={faDiscord} />
                    <span
                      style={{
                        marginLeft: "8px"
                      }}
                    >
                      {getSocials().discord.replace("https://", "")}
                    </span>
                  </Link>
                </Grid>
              )}
              {getSocials().twitch && (
                <Grid item xs={12}>
                  <Link
                    color="inherit"
                    underline="none"
                    href={getSocials().twitch}
                    target="_Blank"
                  >
                    <FontAwesomeIcon icon={faTwitch} />
                    <span
                      style={{
                        marginLeft: "8px"
                      }}
                    >
                      {getSocials().twitch.replace("https://www.twitch.tv", "")}
                    </span>
                  </Link>
                </Grid>
              )}
              {getSocials().youtube && (
                <Grid item xs={12}>
                  <Link
                    color="inherit"
                    underline="none"
                    href={getSocials().youtube}
                    target="_Blank"
                  >
                    <BCPYoutube
                      sx={{ fontSize: "inherit", width: "inherit" }}
                    />
                    <span
                      style={{
                        marginLeft: "8px"
                      }}
                    >
                      {getSocials().youtube.replace(
                        "https://www.youtube.com",
                        ""
                      )}
                    </span>
                  </Link>
                </Grid>
              )}
              {getSocials().threads && (
                <Grid item xs={12}>
                  <Link
                    color="inherit"
                    underline="none"
                    href={getSocials().threads}
                    target="_Blank"
                  >
                    <BCPThreads
                      sx={{ fontSize: "inherit", width: "inherit" }}
                    />
                    <span
                      style={{
                        marginLeft: "8px"
                      }}
                    >
                      {getSocials().threads.replace(
                        "https://www.threads.com",
                        ""
                      )}
                    </span>
                  </Link>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
